"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwareStorage = exports.isFirmwareName = void 0;
const Firmware_1 = require("./Firmware");
const firmwareNames = [
    "BioMea"
];
function isFirmwareName(name) {
    return firmwareNames.indexOf(name) >= 0;
}
exports.isFirmwareName = isFirmwareName;
class FirmwareStorage {
    constructor(otaServer) {
        this.otaServer = otaServer;
        this.otaServer = otaServer.endsWith("/") ? otaServer : otaServer + "/";
    }
    async fetchFirmware(firmwareName, macAddress) {
        const response = await fetch(`${this.otaServer}${firmwareName.toLowerCase()}/?mac=${macAddress}`);
        if (!response.ok) {
            throw new Error("Cannot fetch pending firmware");
        }
        const data = await response.text();
        const lines = data.split("\n");
        const keyValuePairs = lines.map(v => {
            const parts = v.split("=");
            return {
                key: parts[0],
                value: parts.slice(1).join("=")
            };
        }).reduce((prev, curr) => (prev[curr.key] = curr.value, prev), {});
        return new Firmware_1.Firmware(firmwareName, keyValuePairs, this);
    }
    async fetchPendingFirmware(firmwareName) {
        return this.fetchFirmware(firmwareName, "pending");
    }
    async updateFirmware(firmwareName, macAddress) {
        const response = await fetch(`${this.otaServer}${firmwareName.toLowerCase()}/update/${macAddress}/pending`);
        if (!response.ok) {
            try {
                const data = await response.json();
                throw new Error(`There was an error while requesting an firmware update. (code: ${data.errorcode}, error: ${data.error})`);
            }
            catch (ex) {
                throw new Error("There was an error while requesting an firmware update");
            }
        }
    }
}
exports.FirmwareStorage = FirmwareStorage;
FirmwareStorage.default = new FirmwareStorage("https://fw-ota-1.egzotech.com/");
//# sourceMappingURL=FirmwareStorage.js.map